import React from 'react';
import IndustryPageTemplate from '@/components/IndustryPageTemplate';
import { industryAds } from '@/config/ads';

const FinancialServices: React.FC = () => {
  return (
    <IndustryPageTemplate
      slug="financial-services"
      industry="Financial Services"
      heroHeadline="Make complex financial products easier to understand and easier to convert."
      heroSubheadline="Create interactive experiences that build trust, clarify value, and drive qualified applications."
      section2Title="Interactive creative improves clarity and trust."
      section2Content="Financial products are complex. Interactive ads let potential customers explore benefits, compare options, calculate savings, and understand terms—building the clarity and trust needed to convert."
      section3Title="Higher engagement improves acquisition."
      section3Content="When prospects can interact with your products—using calculators, exploring features, comparing plans—they engage more deeply and convert at higher rates. Interactive financial ads turn consideration into action."
      section4Title="Strong fit for banks, credit unions, credit cards, insurance, and investment apps."
      section4Content="Whether you're acquiring new accounts or promoting financial products, Adventive helps you create the clear, trustworthy digital experiences that drive qualified applications."
      heroImage="https://d64gsuwffb70l.cloudfront.net/69408eb499b5789ef7367cf9_1765838723696_d60d606d.jpg"
      heroAd={industryAds.financialServices1}
      section2Ad={industryAds.financialServices2}
      section3Ad={industryAds.financialServices3}
      accentColor="bg-emerald-100 text-emerald-700"
      stats={[
        { value: '3.8x', label: 'Engagement rate' },
        { value: '+75%', label: 'Time on ad' },
        { value: '2.4x', label: 'Application rate' },
        { value: '42%', label: 'Lower CPA' },
      ]}
      benefits={[
        'Banks and credit unions',
        'Credit card issuers',
        'Insurance companies',
        'Investment and fintech apps',
      ]}
    />
  );
};

export default FinancialServices;
